//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vue/no-mutating-props */
/* TODO: fix eslint error */
import { SearchCondition, SearchProp } from "@/utils/dto/search.js";
import EditCharacteristics from "@/components/admin/EditCharacteristics.vue";
import { v4 as uuidv4 } from "uuid";
import { humanReadablePropValue } from "@/utils/converter.js";

export default {
  name: "SearchCondition",
  components: { EditCharacteristics },
  props: {
    value: {
      type: [SearchCondition, Object], //TODO
      default: () => null
    },
    conditionIndex: {
      type: Number,
      default: () => null
    },
    mapSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    conditionsCount: {
      type: Number,
      required: false,
      default: () => 1
    }
  },
  data() {
    return {
      activeIconType: 'circle',
      iconsSubTypes: {
        circle: 'Стандартный балун',
        type: 'Иконка типа',
        photo: 'Фото/иконка объекта',
      },
      propertiesTypes: [],
      openedEditModal: false,
      currentProp: {
        intRangeRule: 0
      },
      operators: [
        { id: 'eq', label: 'равно (x =)' },
        { id: 'in', label: 'от и до (диапазон)' },
        { id: 'gte', label: 'больше (x >)' },
        { id: 'lte', label: 'меньше (x <)' },
        { id: 'nin', label: 'не равно (x !=)' },
      ],
      propValueValidator: function (rule, value, callback) {
        const prop = value.property;

        if (Array.isArray(prop.value) && !prop.value.length) return callback(new Error())
        if (prop.value || prop.date?.vfrom || prop.date?.vto) {
          return callback()
        } else {
          callback(new Error())
        }
      }
    }
  },
  computed: {
    iconsSubTypesSelected() {
      return this.activeIconType in this.iconsSubTypes;
    }
  },
  methods: {
    moveCondition(direction) {
      this.$emit('move', { direction, index: this.conditionIndex })
    },
    selectMapGeoType(type) {
      this.activeIconType = type;
      this.$emit('select-geo-type', { i: this.conditionIndex, type })
    },
    selectMapGeoTypeDd(type) {
      this.selectMapGeoType(type.key);
    },
    fetchTypesCallback(search, limit = 15, offset = 0) {
      return this.$store.dispatch('objects_types/fetchObjects', { q: search, limit: limit, offset: offset })
        .then(({ items, total }) => {
          return {
            items: items.map((type) => {
              return {
                label: type.label,
                id: type.id
              }
            }),
            total: total
          }
        })
        .catch(() => {
          return []
        })
    },
    fetchPropCallback(search, limit = 15, offset = 0) {
      return this.$store.dispatch('property_templates/fetchObjects', {
        q: search,
        limit: limit,
        offset: offset,
        types: this.value.type.id,
        exclude: this.value.props.filter(x => x.prop).map(x => x.prop.id).join(','),
      })
        .then(({ items, total }) => {
          return {
            items: items.map((type) => {
              return {
                label: type.label,
                id: type.id,
                valueType: type.value_type,
                raw: type,
                data: {
                  object: type.value_type === 'object' ? {
                    types: type.value.objects_types,
                    objects: type.value.objects
                  } : null,
                  number: type.value_type === 'number' && type.value_si ? {
                    value: {
                      id: type.value_si_info.id,
                      label: type.value_si_info.name
                    },
                    options: (this.$store.state.property_templates.consts?.si ?? [])
                      .filter(x => x.group === type.value_si_info.group)
                      .map(x => {
                        return {
                          id: x.id,
                          label: x.name,
                        }
                      })
                  } : null,
                  select: type.value_type === 'select' ? type.value.options.map(x => {
                    return {
                      label: x.value,
                      id: x.key
                    }
                  }) : null
                }
              }
            }),
            total: total
          }
        })
        .catch(() => {
          return []
        })
    },
    changePropHandler(index, val) {
      this.value.props[index].value = undefined
      this.value.props[index].query = undefined

      if (val === null) {
        this.value.props[index].valueType = undefined
      } else {
        if (val.valueType === 'number') {
          this.value.props[index].value = {
            number: undefined,
            si: val.data?.number?.value || undefined
          }
          this.value.props[index].operator = this.operators[0].id
        }
        this.value.props[index].valueType = val.valueType
        this.value.props[index].data = val.data
        this.value.props[index].humanReadablePropValue = ""

        this.value.props[index].property = {
          "template": val.raw,
          "value": null,
          "value_si": "",
          "date": { "vfrom": undefined, "vfrom_approx": false, "vto": undefined, "vto_approx": false },
          "touched": true,
          "uuid": uuidv4()
        }
      }
    },
    addProperty() {
      this.value.props.push(new SearchProp())
    },
    deleteProperty(index) {
      this.value.props.splice(index, 1)
    },
    cleanedLabelWithBrackets(option) {
      const regex = /\([^)]*\)/g; // Регулярное выражение для поиска текста в скобках

      return option.label.replace(regex, '');
    },
    editPropValue(propertyOrigin, operator) {
      const property = JSON.parse(JSON.stringify(propertyOrigin))

      let value = property.value
      let intRangeRule = 0
      // конвертация в массив ранее сохраненных значений для чисел
      if (property.template.value.type === 'number') {
        if (operator === 'in') {
          intRangeRule = 1
        } else {
          intRangeRule = 2
        }
        if (!Array.isArray(property.value)) {
          value = [property.value, property.value]
        }
      }

      // восстановление типа значения, если строковое было сохранено как массив
      if (property.template.value.type === 'plain' && Array.isArray(property.value)) {
        value = property.value.join(', ')
      }


      if (property.template.value_type === 'select') {
        property.template.value.many = true
      }

      this.currentProp = {
        intRangeRule: intRangeRule,
        property: {
          ...property,
          date_from: {
            value: property.date?.vfrom || undefined,
            is_approx: property.date?.vfrom_approx || false,
          },
          date_to: {
            value: property.date?.vto,
            is_approx: property.date?.vto_approx || false,
          },
          value: value
        },
        index: property.uuid
      }
      this.openedEditModal = true
    },
    handleSaveProp(payload) {
      const prop = this.value.props.find(x => x.property.uuid === payload.index);
      prop.property = { ...payload.property }
      prop.humanReadablePropValue = humanReadablePropValue(prop.property, this.$store.getters['objects/cachedObjectsGetter']).map(x => x[0]).join(' | ')

      this.openedEditModal = false
    },
    handleChangeOperator(prop) {
      if (prop.operator !== 'in') {
        if (prop.property.value?.[0]) {
          prop.property.value = [prop.property.value?.[0], prop.property.value?.[0]]
        } else {
          prop.property.value = null
        }

        if (prop.property.value) {
          prop.humanReadablePropValue = humanReadablePropValue(prop.property, this.$store.getters['objects/cachedObjectsGetter']).map(x => x[0]).join(' | ')
        } else {
          prop.humanReadablePropValue = ""
        }
      }
    },
    handleChangeType() {
      if (this.value.props.length) this.value.props = [new SearchProp()]
    }
  },
}
